import React, { PureComponent } from 'react';
import { Icon } from 'appSrc/components/UI';
import style from './styles/style.module.css';


class FacebookShare extends PureComponent {
    constructor(props) {
        super(props);
    }
    share = () => {
        var url = this.props.url !== null ? this.props.url : window.location.href;
        FB.ui( {
            method: 'share',
            href: url,
        }, ()=>{} );

        if( this.props.trackShare ) {
            this.props.trackShare( 'facebook' );
        }
    }
    render() {
        return (
            <div className={ style.facebookShare } style={ this.props.style } onClick={ this.share }>
                <Icon source='fontAwesome' icon='fab/faFacebook' alt='Facebook Share' size={ null } />
            </div>
        );
    }
}
FacebookShare.defaultProps = {
    url: null,
};

export default FacebookShare;
